// 表格表头
export let tableLabels = [
  {
    label: '视频名称',
    value: 'name'
  },
  {
    label: '视频状态',
    value: 'status_copy'
  },
  {
    label: '发布时间',
    value: 'publishTime_copy'
  },
  {
    label: '创建时间',
    value: 'createTime_copy'
  }
]
// 选择商品的列表顶部筛选
export let filterItems = [
  {
    label: '发布时间',
    type: 'time-slot',
    value: 'publishTime',
    startName: 'publishStart',
    endName: 'publishEnd'
  }
]
